<!-- <h1>Enter Mobile Number AND Pin For Login</h1>
<mat-form-field appearance="fill" style="width: 100% !important;">
    <mat-label>MOBILE NUMBER</mat-label>
    <input matInput type="number" [(ngModel)]="mobileNumber">
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 100% !important;">
    <mat-label>PIN</mat-label>
    <input matInput type="number" [(ngModel)]="pinNumber">
  </mat-form-field>
  <div class="example-button-row">
    <button class= "subButton" mat-button color="primary" (click)="submit()">SUBMIT</button>
  </div> -->
  <div *ngIf="queryParam.id != '322'">
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Username AND Password verification</h4>
</div>
<div class="modal-body">
  <form>
    <div class="mb-3">
      <label for="dateOfBirth">Enter Username :<span style="color: brown;">{{addbalance}}</span></label>
      <div class="input-group">
        <input type="number" id="dateOfBirth" class="form-control" placeholder="Username" name="dp"
          [(ngModel)]="mobileNumber">
      </div>
    </div>
    <div class="mb-3">
      <label for="dateOfBirth">Enter Password :</label>
      <div class="input-group">
        <input type="number" id="dateOfBirth" class="form-control" placeholder="Password" name="dp"
          [(ngModel)]="pinNumber">
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="submit()">SUBMIT</button>
</div>
</div>


<div *ngIf="queryParam.id == '322' && queryParam.biller == 'TPAY' && queryParam.lang == 'EN'">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobile Number</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label for="dateOfBirth">Enter Mobile Number :<span style="color: brown;">{{addbalance}}</span></label>
        <div class="input-group mt-3">
          <input type="number" id="dateOfBirth" class="form-control" placeholder="" name="dp"
            [(ngModel)]="mobileNumber">
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitMsisdn()">SUBMIT</button>
  </div>
</div>

<div *ngIf="queryParam.id == '322' && queryParam.biller == 'TPAY' && queryParam.lang == 'AR'">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mobile Number</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="mb-3">
        <label for="dateOfBirth">أدخل رقم الهاتف المتحرك :<span style="color: brown;">{{addbalance}}</span></label>
        <div class="input-group mt-3">
          <input type="number" id="dateOfBirth" class="form-control" placeholder="" name="dp"
            [(ngModel)]="mobileNumber">
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submitMsisdn()">SUBMIT</button>
  </div>
</div>